import axios from "axios"
import {MESSAGING_URL} from "../globals"
import {handleError} from "../helpers/errors"


const URL = {
  UNSUBSCRIBE_EMAIL: "/unsubscribe-email/",
}


const axiosInstance = axios.create({
  baseURL: MESSAGING_URL,
})
axiosInstance.interceptors.response.use(null, handleError)


export const unsubscribeEmail = (email, category) => {
  return axiosInstance.post(URL.UNSUBSCRIBE_EMAIL, {
    email: email,
    category: category,
  })
}
